import { CheckZipResponse } from "./CheckZipResponse";

export type AddressState = { id?: string; create?: AddressCreationState };

export type AddressCreationState = {
  zipCode?: string;
  companyName?: string;
  street?: string;
  houseNumber?: string;
  contactName?: string;
  contactPhone?: string;
  extraInfo?: string;
  isZipValidationLoading: boolean;
  validatedZip?: CheckZipResponse;
};

export class CreateAddressRequest {
  companyName: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  contactName?: string;
  contactPhone?: string;
  extraInfo?: string;
  constructor(creation: AddressCreationState) {
    this.companyName = creation.companyName!;
    this.street = creation.street!;
    this.houseNumber = creation.houseNumber!;
    this.zipCode = creation.zipCode!;
    this.city = creation.validatedZip!.city;
    this.contactName = creation.contactName;
    this.contactPhone = creation.contactPhone;
    this.extraInfo = creation.extraInfo;
  }
}
